import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { faLock, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from '../authentication/authentication.service';
import { valuationByHash } from '../models/valuation.model';
import { SHARED_IMPORTS } from '../shared/standalone-imports';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class HeaderComponent implements OnInit {
  public faLock = faLock;
  public faTimes = faTimes;
  public valuationData: valuationByHash;
  public acceptForm: any;
  public status = false;

  @Output() fire: EventEmitter<any> = new EventEmitter();
  constructor(private readonly authService: AuthenticationService) {
    this.getData();
  }

  public ngOnInit(): void {
    setInterval(() => {
      this.getData();
    }, 500);
  }

  public getData() {
    if (localStorage.getItem('valuationData')) {
      this.valuationData = JSON.parse(localStorage.getItem('valuationData'));
    } else {
      this.valuationData = null;
    }

    if (localStorage.getItem('acceptForm')) {
      this.acceptForm = JSON.parse(localStorage.getItem('acceptForm'));
    } else {
      this.acceptForm = null;
    }
  }

  public logout() {
    this.authService.logout();
  }
}
